import { useGqlQueryInvalidate } from '@/utilities/gqlQuery';
import { useCallback } from 'react';

export const useNarrativeInvalidate = () => {
  const invalidateQueries = useGqlQueryInvalidate();

  const invalidate = useCallback(
    () => invalidateQueries(['narrative']),
    [invalidateQueries]
  );

  return {
    invalidate,
  };
};
